import { Children, isValidElement, ReactNode } from 'react';

/**
 * Recursively extracts plain text from a React node tree.
 * Handles strings, numbers, arrays, fragments, and elements with children.
 *
 * Used to produce non-empty `text` values for FAQPage JSON-LD structured data
 * even when the visible answer uses JSX (links, bold text, etc.). Empty `text`
 * triggers Google Rich Results validation errors.
 */
export function extractTextFromReactNode(node: ReactNode): string {
  if (node == null || typeof node === 'boolean') return '';
  if (typeof node === 'string') return node;
  if (typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(extractTextFromReactNode).join('');
  if (isValidElement(node)) {
    return extractTextFromReactNode(
      Children.toArray((node.props as { children?: ReactNode }).children),
    );
  }
  return '';
}
